import validate from 'validate.js'

const constraints = {
  user: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
